import { createSelector } from 'reselect';
import { DateUtils } from '../../utils';
import { FieldType, TripType } from '../../models';
import { getDestinationSelector, getOriginSelector } from '../currentSearch/selectors';

const getPreviousSearches = ({ previousSearches }) => previousSearches.items;

const getDateFilteredSearches = (searches) => {
    return searches.filter((search) => {
        const date = search.segments[0].date;
        return search.segments.length > 0 && DateUtils.isNotExpired(date);
    });
};

const getLegsFromPreviousSearches = (previousSearches) => {
    const legs = getDateFilteredSearches(previousSearches).map((search) => {
        const { segments, tripType } = search;
        return segments.slice(0, tripType === TripType.MULTIPLE ? segments.length : 1);
    });
    return [].concat(...legs);
};

const getPreviousSearchesCities = (searches, field, city) => {
    const cityIata = city ? city.iata : null;
    return getLegsFromPreviousSearches(searches)
        .map((leg) => field === FieldType.DEPARTURE ? leg.origin : leg.destination)
        .filter((elem) => elem.iata !== cityIata)
        .filter((elem, index, self) => index === self.findIndex((city)=> city.iata === elem.iata));
};

export const getFilteredPreviousSearches = createSelector(
    [getPreviousSearches],
    (previousSearches) => getDateFilteredSearches(previousSearches)
);

export const getFilteredPreviousSearchesDepartureCities = createSelector(
    [getPreviousSearches, getDestinationSelector],
    (previousSearches, destination) => getPreviousSearchesCities(previousSearches, FieldType.DEPARTURE, destination)
);

export const getFilteredPreviousSearchesDestinationCities = createSelector(
    [getPreviousSearches, getOriginSelector],
    (previousSearches, origin) => getPreviousSearchesCities(previousSearches, FieldType.ARRIVAL, origin)
);
